import { WifiPassword } from "@mui/icons-material";
import { Alert, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ButtonPill } from "../theme/StyledFields";
import {
  type AuthProcessName,
  requestNativeAppleSignIn,
  subscribeNativeAuth,
} from "../utils/nativeAuthBridge";
import { AuthProcess } from "./lib/allauth";
import { ReactComponent as Apple } from "./logos/apple.svg";

interface AppleInAppButtonProps {
  isConnected: boolean;
  process?: AuthProcessName;
}

const AppleInAppButton: React.FC<AppleInAppButtonProps> = ({
  isConnected = false,
  process = AuthProcess.LOGIN,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return subscribeNativeAuth((result) => {
      setLoading(false);
      if (result.status === "error") {
        if (result.code === "cancelled") {
          setError(null);
          return;
        }
        setError(result.message || "Apple sign-in failed");
      } else {
        setError(null);
      }
    });
  }, []);

  const handleClick = async () => {
    setLoading(true);
    setError(null);
    try {
      await requestNativeAppleSignIn(process);
    } catch (err) {
      setLoading(false);
      setError(err instanceof Error ? err.message : "Apple sign-in failed");
    }
  };

  return (
    <React.Fragment>
      <ButtonPill
        onClick={() => void handleClick()}
        data-attr="apple-in-app-button_sign-in"
        startIcon={loading ? <CircularProgress size={20} /> : <Apple />}
        disabled={loading}
        endIcon={isConnected ? <WifiPassword /> : undefined}
        fullWidth
        variant={"outlined"}
        color={"inherit"}
      >
        Sign in with Apple
      </ButtonPill>
      {error && <Alert severity="error">{error}</Alert>}
    </React.Fragment>
  );
};

export default AppleInAppButton;
